<template>
  <data-validation
    :auth="auth"
    :title="$t('reservation.data_validation_access')"
    :description="$t('reservation.data_validation_access_description')"
    :contacts="contacts"
    :is-loading="isLoading || isLoadingData"
    :back-btn-text="$t('reservation.back_button')"
    @change="changeAuth({ validationMethod: $event })"
    @send="sendGuestPin"
    @back="$router.push({ name: currentStep.route })"
  />
</template>

<script setup>
import { onMounted } from "vue"
import { useNamespacedState } from "vuex-composition-helpers/dist"

import { useStoreAction } from "@/composables"

import DataValidation from "./components/DataValidation.vue"
import { usePersonValidation } from "./usePersonValidation"

const { guest } = useNamespacedState("guest", ["guest"])
const { getAuthData, isLoading: isLoadingData } = useStoreAction(
  "guest/auth",
  "getAuthData"
)

onMounted(() => {
  getAuthData(guest.value)
})

const { auth, contacts, isLoading, changeAuth, sendGuestPin, currentStep } =
  usePersonValidation()
</script>
